import React from 'react';

/**
 * Unified Loading Spinner Component
 * Provides a consistent loading experience across the entire application
 * 
 * @param {string} message - Optional custom loading message
 * @param {string} size - Size of the spinner: 'sm', 'md', 'lg' (default: 'md')
 * @param {boolean} fullScreen - Whether to display as full screen loader (default: true)
 */
const LoadingSpinner = ({ 
  message = "Loading...", 
  size = "md",
  fullScreen = true 
}) => {
  // Size configurations
  const sizeClasses = {
    sm: "h-6 w-6",
    md: "h-8 w-8",
    lg: "h-12 w-12"
  };

  const textSizeClasses = {
    sm: "text-base",
    md: "text-lg",
    lg: "text-xl"
  };

  const spinnerSize = sizeClasses[size] || sizeClasses.md;
  const textSize = textSizeClasses[size] || textSizeClasses.md;

  const content = (
    <div className="flex items-center space-x-4">
      <div className={`animate-spin rounded-full ${spinnerSize} border-b-2 border-sunrise-red`}></div>
      <span className={`text-grey-dusk font-medium ${textSize}`}>
        {message}
      </span>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen bg-green-cloud flex items-center justify-center">
        {content}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-8">
      {content}
    </div>
  );
};

export default LoadingSpinner;
